import React from 'react';
import {styled, Tooltip} from '@mui/material';

const StyledTooltipComp = styled(props=>{
    let {className, ...rest} = props;
    return <Tooltip classes={{tooltip: className}} {...rest}/>;
})`
    background-color: ${p=>p.theme.palette.primary.darkTransparent};
`;

const StyledTooltip = props=><StyledTooltipComp {...props}/>;

export default StyledTooltip;
